// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import OverviewPage from './pages/OverviewPage';
import GatewaysPage from './pages/GatewaysPage';
import GatewayDetailPage from './pages/GatewayDetailPage';
import WaterMetersPage from './pages/WaterMetersPage';
import WaterMeterDetailPage from './pages/WaterMeterDetailPage';
import CriticalsPage from './pages/CriticalsPage';
import GatewayRegistration from './pages/GatewayRegistration';
import WaterMeterRegistration from './pages/WaterMeterRegistration';
import SearchResultsPage from './pages/SearchResultsPage';
import DashboardLayout from './components/DashboardLayout';
import LostWaterMetersPage from './pages/LostWaterMetersPage.js';
import DownWaterMetersPage from './pages/DownWaterMetersPage.js';
import LostGatewaysPage from './pages/LostGatewaysPage.js';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* Nested routes inside the dashboard */}
          <Route index element={<OverviewPage />} />
          <Route path="gateways" element={<GatewaysPage />} />
          <Route path="gateways/:gatewayId" element={<GatewayDetailPage />} />
          <Route path="lost-gateways" element={<LostGatewaysPage />} />
          <Route path="water-meters" element={<WaterMetersPage />} />
          <Route path="water-meters/:meterId" element={<WaterMeterDetailPage />} />
          <Route path="lost-water-meters" element={<LostWaterMetersPage />} />
          <Route path="down-water-meters" element={<DownWaterMetersPage />} />
          <Route path="criticals" element={<CriticalsPage />} />
          <Route path="gateway-registration" element={<GatewayRegistration />} />
          <Route path="water-meter-registration" element={<WaterMeterRegistration />} />
          <Route path="search" element={<SearchResultsPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
